import { ServiceResult } from '../models';
import { RecipeUom } from '../models/recipe-uom.models';
import ApiService from './api-service';

export default class RecipeUomService extends ApiService {
  private static classInstance: RecipeUomService;

  private constructor() {
    super('RecipeUnitOfMeasure');
  }

  public static getInstance(): RecipeUomService {
    if (!this.classInstance) {
      this.classInstance = new RecipeUomService();
    }
    return this.classInstance;
  }

  public getRecipeUnitOfMeasures(): ServiceResult<RecipeUom[]> {
    return this.get(`${this.baseUrl}/GetRecipeUnitOfMeasures`);
  }
}
